import React from 'react';

// Inline styles so overlay always applies in prod (no Tailwind purge of dynamic classes)
const overlayStyles = {
  light: { backgroundColor: 'rgba(255, 255, 255, 0.95)' },
  dark: { backgroundColor: 'rgba(255, 255, 255, 0.9)' },
  gradient: {
    background: 'linear-gradient(to bottom right, rgba(255,255,255,0.97), rgba(255,255,255,0.95), rgba(241, 86, 43, 0.05))',
  },
};

export function SlideWrapper({ children, className = '', id, backgroundImage, overlay = 'light' }) {
  return (
    <section
      id={id}
      className={`relative flex min-h-screen w-full flex-col justify-center overflow-hidden px-8 py-16 md:px-20 lg:px-32 text-lg ${className}`}
    >
      {backgroundImage && (
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        />
      )}
      {backgroundImage && (
        <div className="absolute inset-0" style={overlayStyles[overlay]} />
      )}
      <div className="absolute top-6 right-8 z-10 text-xs tracking-widest uppercase opacity-40 text-gray-700">
        Jobotics
      </div>
      <div className="relative z-10">
        {children}
      </div>
    </section>
  );
}
